import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StyledTableHeadingCell } from "../../../../../common/components/functional/simpleTable/styled";

type Props = {
  fields: { name: string; width?: string }[];
};

export const PayslipRowHeader = ({ fields }: Props) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      {fields.map((field, i) => (
        <StyledTableHeadingCell width={field.width || "200px"} key={i}>
          {t(`payslips:${field.name}`)}
        </StyledTableHeadingCell>
      ))}
      <StyledTableHeadingCell />
    </TableRow>
  );
};
